import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Label, Note } from 'app/modules/gen/notes/notes.types';
import { environment } from 'environments/environment';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})
export class EntityService {
  // Private
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  private _labels: BehaviorSubject<Label[] | null> = new BehaviorSubject(null);
  private _note: BehaviorSubject<Note | null> = new BehaviorSubject(null);
  private _notes: BehaviorSubject<Note[] | null> = new BehaviorSubject(null);
  private _baseURL: string = environment.apiOrigin + '/apiv1/'
  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient, private _snackBar: MatSnackBar) {
    console.log('innnnnnnnnnnnnnnnnnnn')
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for labels
   */
  get labels$(): Observable<Label[]> {
    return this._labels.asObservable();
  }

  /**
   * Getter for notes
   */
  get notes$(): Observable<Note[]> {
    return this._notes.asObservable();
  }

  /**
   * Getter for note
   */
  get note$(): Observable<Note> {
    return this._note.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  new_note(data) { return this._httpClient.post(this._baseURL + 'entity/note', { data: data }); }
  update_note(data) { return this._httpClient.put(this._baseURL + `entity/note/${data.nte_id}`, { data: data }); }
  new_folder(data) {
    return this._httpClient.post(this._baseURL + 'entity/folder', { data: data });
  }

  get_notes() { return this._httpClient.get(this._baseURL + 'entity/notes'); }
  remove_note(data) { return this._httpClient.delete(this._baseURL + `entity/remove_note/${data.nte_id}/${data.enty_id}`); }
  new_document(data) {
    return this._httpClient.post(this._baseURL + 'entity/document', { data: data });
  }
  updte_document(data) {
    return this._httpClient.put(this._baseURL + 'entity/document/' + data.dcmnt_id, { data: data });
  }
  get_documents() {
    return this._httpClient.get(this._baseURL + 'entity/documents/list');
  }
  remove_document(dcmnt_id) {
    return this._httpClient.delete(this._baseURL + `entity/document/${dcmnt_id}`);
  }
  get_document_categories(hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/document-categories/${hndlr_nm}`);
  }
  get_document_types(dcmnt_ctgry_id) {
    return this._httpClient.get(this._baseURL + `entity/document-types/${dcmnt_ctgry_id}`);
  }
  new_contact(data) {
    return this._httpClient.post(this._baseURL + 'entity/contact', { data: data });
  }
  updte_contact(data) {
    return this._httpClient.put(this._baseURL + 'entity/contact/' + data.cntct_id, { data: data });
  }
  get_contacts() {
    return this._httpClient.get(this._baseURL + 'entity/contacts/list');
  }
  remove_contact(cntct_id) {
    return this._httpClient.delete(this._baseURL + `entity/contact/${cntct_id}`);
  }
  get_contacts_types(hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/contact-types/${hndlr_nm}`);
  }
  get_note_hndlr(id, hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/noteHndlr/${id}/${hndlr_nm}`);
}
  new_address(data) {
    return this._httpClient.post(this._baseURL + 'entity/address', { data: data });
  }
  updte_address(data) {
    return this._httpClient.put(this._baseURL + 'entity/address/' + data.adrs_id, { data: data });
  }
  get_addresses() {
    return this._httpClient.get(this._baseURL + 'entity/address/list');
  }
  remove_address(adrs_id) {
    return this._httpClient.delete(this._baseURL + `entity/address/${adrs_id}`);
  }
  get_location_types(hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/location-types/${hndlr_nm}`);
  }
  get_states() {
    return this._httpClient.get(this._baseURL + `auth/states/list`);
  }
  get_districts(ste_id) {
    return this._httpClient.get(this._baseURL + `auth/districts/list/${ste_id}`);
  }
  get_weeks() {
    return this._httpClient.get(this._baseURL + 'entity/get_weeks');
  }
  get_tmngs_hndlr(id, hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/get_facilityTimingsHndlr/${id}/${hndlr_nm}`);
  }
  remove_tmngs_hndlr(enty_ky,wk_dy_id, hndlr_nm) {
    return this._httpClient.delete(this._baseURL + `entity/remove_facilityTimingsHndlr/${enty_ky}/${wk_dy_id}/${hndlr_nm}`);
  }
  remove_hldys_hndlr(enty_ky,date_id, hndlr_nm) {
    return this._httpClient.delete(this._baseURL + `entity/remove_HldysHndlr/${enty_ky}/${date_id}/${hndlr_nm}`);
  }
  post_weeksTmngs(data) {
    return this._httpClient.post(this._baseURL + 'cpay/web/add/collection/type/timings', { data: data });
  }
  post_twntyFrhrs(data) {
    return this._httpClient.post(this._baseURL + 'entity/twntyFrhrs', { data: data });
  }
  get_tmngs_hndlrs(clctn_type_id) {
    return  this._httpClient.get(this._baseURL + `cpay/web/collection/type/timings/${clctn_type_id}`);
  }
 
  get_facilityTimings() {
    return this._httpClient.get(this._baseURL + 'entity/get_facilityTimings');
  }

  get_prvsRvws(hndlr_nm, enty_ky) {
    return this._httpClient.get(this._baseURL + `entity/previous-review/${hndlr_nm}/${enty_ky}`);
  }
  add_rvw(data) {
    return this._httpClient.post(this._baseURL + 'entity/review', { data: data });
  }
  updte_rvw(data) {
    return this._httpClient.put(this._baseURL + 'entity/review/' + data.rvw_id, { data: data });
  }
  // getDatesLst() {
  //   return this._httpClient.get(this._baseURL + 'entity/get_dates');
  // }
  addHoliday(data) { return this._httpClient.post(this._baseURL + 'entity/add_holiday', { data: data }); }
  updteHoliday(data) {
    return this._httpClient.put(this._baseURL + 'entity/upd_holiday', { data: data });
  }
  getDcmnts(id, hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/documents/${id}/${hndlr_nm}`);
  };
  getAddress(id, hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/address/${id}/${hndlr_nm}`);
  }
  getEntyIndctrs(hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/indicators/${hndlr_nm}`);
  }
  getContacts(id, hndlr_nm) {
    return this._httpClient.get(this._baseURL + `entity/contacts/${id}/${hndlr_nm}`);
  }
  openSnackBar(msg, cls) {
    this._snackBar.open(msg, '', {
      duration: 3000,
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      panelClass: ['mat-toolbar', cls]
    });
  }
}
